import React, { useEffect, useState, } from 'react'
import { useParams } from 'react-router';

import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';

import {
    checkIfCallPrinterAsync, responseGet, globalSettings, numberSet, separatorsNumbersSet, styles, sendMessageCloseCurrentWindowAsync, dateTimeFormatGlobalSet, awaitDelay, languageObjGet,
    isUndNullEmp, LoadingSection,
} from '../../helpers/settings';
import HtmlParser from 'react-html-parser';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { bankModelGet } from '../../models/banks/bank';
import { bankAccountModelGet } from '../../models/bankAccounts/bankAccount';
import { coinModelGet } from '../../models/coins/coin';
import { userModelGet } from '../../models/users/user';
import { apartmentModelGet } from '../../models/apartments/apartment';
import { apartmentReceiptModelGet } from '../../models/apartments/apartmentReceipt';
import { purchaseModelGet } from '../../models/expenses/purchase';

const currentMethod = 'BankAccountMovementsPrint';
const neutralValue = 0.00;

const { app, collections: dbColle, icons, labels, messages, } = globalSettings;
const { backend, } = app;

export default function BankAccountMovementsPrint({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let headerObj = {};
    const auth = useAuth();
    const { id, } = useParams();
    const descriptionPercentageObj = {
        success: 'description-percentage text-success',
        primary: 'description-percentage text-primary',
        danger: 'description-percentage text-danger',
    };
    //#endregion variables

    //#region building
    const [building, setBuilding] = useState(buildingModelGet({}));
    //#endregion building

    //#region showLoading
    const [showLoading, setShowLoading] = useState(true);
    //#endregion showLoading

    //#region movements
    const [reportData, setReportData] = useState({
        dateFrom: '',
        dateTo: '',
        building: buildingModelGet({}),
        coin: coinModelGet({}),
        bank: bankModelGet({}),
        bankAccount: bankAccountModelGet({}),
        user: userModelGet({}),
        movements: [],
    });
    //#endregion movements

    //#region bank
    const [bank, setBank] = useState(bankModelGet({}));
    //#endregion bank

    //#region bank account
    const [bankAccount, setBankAccount] = useState(bankAccountModelGet({}));
    //#endregion bank account

    //#region coin
    const [coin, setCoin] = useState(coinModelGet({}));
    //#endregion coin

    //#region user
    const [user, setUser] = useState(userModelGet({}));
    //#endregion user

    //#region methods
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let reportData = {
                dateFrom: '',
                dateTo: '',
                building: buildingModelGet({}),
                coin: coinModelGet({}),
                bank: bankModelGet({}),
                bankAccount: bankAccountModelGet({}),
                user: userModelGet({}),
            };
            let showPrinterPromp = false;
            //#endregion variables

            setShowLoading(true);

            //#region report get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlReports}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            reportData = response?.result || {};
            setReportData(reportData);
            //#endregion report get

            //#region bank get
            setBank(reportData?.bank || {});
            //#endregion bank get

            //#region bankAccount get
            setBankAccount(reportData?.bankAccount || {});
            //#endregion bankAccount get

            //#region coin get
            setCoin(reportData?.coin || {});
            //#endregion coin get

            //#region building get
            setBuilding(reportData?.building || {});
            //#endregion building get

            //#region user get
            setUser(reportData?.user || {});
            //#endregion building get

            //#region show printer promp
            response = await checkIfCallPrinterAsync({
                checkIfOnlyIsMobile: false,
                subMetho: currentMethod,
            });

            if (!response.isSuccess) {
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: true,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            showPrinterPromp = response?.result || false;

            setShowLoading(false);

            if (showPrinterPromp) {
                await awaitDelay(globalSettings?.timers?.oneSecond);
                window?.addEventListener('load', window?.print());
            }
            //#endregion show printer promp
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: true,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataDetailGet = ({
        processType = 0,
        movement = {
            id: '',
            bankAccountId: '',
            date: new Date(),
            dateTwo: new Date(),
            collection: '',
            type: '',
            apartment: apartmentModelGet({}),
            apartmentReceipt: apartmentReceiptModelGet({}),
            purchase: purchaseModelGet({}),
            reference: '',
            subType: {
                id: '',
                description: '',
            },
            created: new Date(),
            referenceData: '',
            amount: neutralValue,
            balance: neutralValue,
        },
        subMethod = '',
    }) => {
        const currentMethod = 'dataDetailGet';
        let response = responseGet();
        try {
            switch (processType) {
                case 0:
                    response.result = movement?.id;
                    break;
                case 1:
                    response.result = dateTimeFormatGlobalSet({
                        date: movement?.date,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        secondsShow: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                case 2:
                    if (movement?.type !== 0) {
                        response.result = `${labels?.type?.[languageObj?.id]}: ${movement?.type === 1 ? labels?.income?.[languageObj?.id] : labels?.egress?.[languageObj?.id]}; `;
                        switch (movement?.collection) {
                            case dbColle?.apartmentReceiptPayments:
                                if (!isUndNullEmp({ data: movement?.apartment?.id, subMethod: currentMethod, })?.result) {
                                    response.result += `${labels?.apartment?.[languageObj?.id]}: ${movement?.apartment?.identifier}; `;
                                }
                                if (!isUndNullEmp({ data: movement?.apartmentReceipt?.id, subMethod: currentMethod, })?.result) {
                                    response.result += `${labels?.receipt?.[languageObj?.id]}: ${movement?.apartmentReceipt?.receiptNumberApartment}; `;
                                }
                                response.result += `${labels?.date?.[languageObj?.id]}: ${
                                    //dateTimeFormatGlobalSet(movement?.dateTwo, languageObj?.format?.date?.f1, 0)?.result
                                    dateTimeFormatGlobalSet({
                                        date: movement?.dateTwo,
                                        type: languageObj?.format?.date?.f1,
                                        format: 0,
                                        addTime: false,
                                        secondsShow: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    })?.result
                                    }; `;
                                break;
                            case dbColle?.purchasePayments:
                                if (!isUndNullEmp({ data: movement?.purchase?.id, subMethod: currentMethod, })?.result) {
                                    response.result += `${labels?.purchase?.[languageObj?.id]}: ${movement?.purchase?.number}; `;
                                    response.result += `${labels?.number?.[languageObj?.id]}: ${movement?.purchase?.invoiceNumber}; `;
                                    response.result += `${labels?.date?.[languageObj?.id]}: ${
                                        //dateTimeFormatGlobalSet(movement?.purchase?.date, languageObj?.format?.date?.f1, 0)?.result
                                        dateTimeFormatGlobalSet({
                                            date: movement?.purchase?.date,
                                            type: languageObj?.format?.date?.f1,
                                            format: 0,
                                            addTime: false,
                                            secondsShow: false,
                                            languageId: languageObj?.id,
                                            subMethod: currentMethod,
                                        })?.result
                                        }; `;
                                }
                                break;
                            case dbColle?.bankAccountMovements:
                                //response.result += `${replaceMessages(0, movement?.reference)?.result}; `;
                                response.result += `${movement?.reference}; `;
                                if (!isUndNullEmp({ data: movement?.subType?.id, subMethod: currentMethod, })?.result) {
                                    response.result += `${movement?.subType.description}; `;
                                }
                                response.result += `${labels?.date?.[languageObj?.id]}: ${
                                    //dateTimeFormatGlobalSet(movement?.created, languageObj?.format?.date?.f1, 0)?.result
                                    dateTimeFormatGlobalSet({
                                        date: movement?.created,
                                        type: languageObj?.format?.date?.f1,
                                        format: 0,
                                        addTime: false,
                                        secondsShow: false,
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    })?.result
                                    }; `;
                                break;
                            default:
                                break;
                        }

                        if (movement?.collection === dbColle?.bankAccountMovements) {
                            response.result += `${labels?.reference?.[languageObj?.id]}: ${(
                                !isUndNullEmp({ data: movement?.referenceData, subMethod: currentMethod, })?.result ?
                                    movement?.referenceData :
                                    ''
                            )}`;
                        } else {
                            //response.result += `${labels?.reference?.[languageObj?.id]}: ${replaceMessages(0, movement?.reference)?.result}`;
                            response.result += `${labels?.reference?.[languageObj?.id]}: ${movement?.reference}`;
                        }
                    } else {
                        if (movement?.id !== movement?.collectionCashId) {
                            //response.result = `${labels?.reference?.[languageObj?.id]}: ${replaceMessages(0, movement?.reference)?.result}`;
                            response.result = `${labels?.reference?.[languageObj?.id]}: ${movement?.reference}`;
                        } else {
                            //response.result = `${replaceMessages(0, movement?.reference)?.result}`;
                            response.result = `${movement?.reference}`;
                        }
                    }
                    break;
                case 3:
                    response.result = movement?.id !== movement?.bankAccountId ?
                        separatorsNumbersSet({
                            number: movement?.amount,
                            withDecimals: true,
                            consoleLogErrorShow: true,
                            subMethod: currentMethod,
                        })?.result :
                        '';
                    break;
                case 4:
                    response.result = separatorsNumbersSet({
                        number: movement?.balance,
                        withDecimals: true,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result;
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [id]) //eslint-disable-line react-hooks/exhaustive-deps

    //#endregion methods
    return (
        <div>
            {/* <div style={{margin: '3px'}}> */}
            {!showLoading ?
                <div className='container mt-4'>
                    <div className='card card-outline card-secondary elevation-3 shadow-lg'>
                        <div className='card-header'>
                            <h5 className='card-title'>
                                <img src={globalSettings?.images?.appLogo}
                                    alt='appLogo'
                                    className='brand-image img-circle elevation-3'
                                    style={styles.receiptPrintLogo} /> {app?.name}

                                <div className='text-muted' style={{ fontSize: '13px' }}>
                                    {HtmlParser(globalSettings?.html?.space?.formatSevenTeen)}{messages?.theOnlyAndBestProgramInCondominiumManagement?.[languageObj?.id]}
                                </div>
                            </h5>

                            <div className='card-tools text-small'>
                                <ul className='list-unstyled float-right'>
                                    <li>
                                        {/* {`${labels?.date?.[languageObj?.id]}:`} <b>{`${dateTimeFormatSetTwo(new Date(), languageObj?.format?.date?.f1, 0)}`}</b> */}
                                        {`${labels?.date?.[languageObj?.id]}:`} <b>{
                                            dateTimeFormatGlobalSet({
                                                date: new Date(),
                                                type: languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: false,
                                                secondsShow: false,
                                                languageId: languageObj?.id,
                                                subMethod: currentMethod,
                                            })?.result
                                        }</b>
                                    </li>
                                    <li>
                                        {`${labels?.time?.[languageObj?.id]}:`} <b>{
                                            dateTimeFormatGlobalSet({
                                                date: new Date(),
                                                type: '',
                                                format: languageObj?.format?.time?.type,
                                                addTime: false,
                                                secondsShow: false,
                                                languageId: languageObj?.id,
                                                subMethod: currentMethod,
                                            })?.result
                                        }</b>
                                    </li>
                                    <li>
                                        {`${labels?.user?.[languageObj?.id]}:`} <b>{
                                            !isUndNullEmp({ data: user?.displayName, subMethod: currentMethod, })?.result ?
                                                user?.displayName :
                                                `${user?.firstName || ''}, ${user?.lastName || ''}`
                                        }</b>
                                    </li>
                                </ul>
                            </div>

                            {/* <div className='row'>
                                    <div className='col-12'>
                                        <h4 className='page-header'>
                                            <img src={globalSettings?.images?.appLogo} 
                                                alt='appLogo' 
                                                className='brand-image img-circle elevation-3'
                                                style={styles.receiptPrintLogo} /> {app?.name}
                                            <ul className='list-unstyled float-right'>
                                                <li>
                                                    <small>{`${labels?.date?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), languageObj?.format?.date?.f1, 0)}`}</small>
                                                </li>
                                                <li>
                                                    <small>{`${labels?.time?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), '', 12)}`}</small>
                                                </li>
                                            </ul>
                                        </h4>
                                    </div>
                                </div> */}
                        </div>
                        <div className='card-body'>

                            {/* <div className='row'> */}
                            <div className='text-center'>
                                <h5>{labels?.bankAccountMovements?.[languageObj?.id]}</h5>
                            </div>
                            {/* </div> */}

                            <section className='invoice'>

                                {/* title row */}
                                {/* <div className='row'>
                                        <div className='col-12'>
                                            <h4 className='page-header'>
                                                <img src={globalSettings?.images?.appLogo} 
                                                    alt='appLogo' 
                                                    className='brand-image img-circle elevation-3'
                                                    style={styles.receiptPrintLogo} /> {app?.name}
                                                <ul className='list-unstyled float-right'>
                                                    <li>
                                                        <small>{`${labels?.date?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), languageObj?.format?.date?.f1, 0)}`}</small>
                                                    </li>
                                                    <li>
                                                        <small>{`${labels?.time?.[languageObj?.id]}: ${dateTimeFormatSetTwo(new Date(), '', 12)}`}</small>
                                                    </li>
                                                </ul>
                                            </h4>
                                        </div>
                                    </div> */}
                                {/* 
                                    <div className='row'>
                                        <div className='cold-12'>
                                            <hr />
                                        </div>
                                    </div> */}

                                {/* info row */}
                                <div className='row invoice-info'>
                                    <div className='col-sm-4 invoice-col'>
                                        <address className='mx-2'>
                                            {labels?.building?.[languageObj?.id]}: <b>{building.description || ''}</b><br />
                                            {labels?.phone?.[languageObj?.id]}: {building?.phoneNumber || ''}<br />
                                            {labels?.address?.[languageObj?.id]}: {building?.address || ''}<br />
                                            {labels?.email?.[languageObj?.id]}: {building?.email || ''}<br />
                                            {/* <i className='far fa-building'></i> <b>{!isUndefined(building.description) ? building.description : ''}</b><br/>
                                                <i className='fas fa-mobile-alt'></i> {!isUndefined(building.phoneNumber) ? building.phoneNumber : ''}<br/>
                                                <i className={icons?.mapMarker}></i> {!isUndefined(building.address) ? building.address : ''}<br/>
                                                <i className={icons?.envelope}></i> {!isUndefined(building.email) ? building.email : ''}<br/> */}
                                        </address>
                                    </div>
                                    {/* /.col */}
                                    <div className='col-sm-4 invoice-col border-left'>
                                        <address>
                                            {labels?.bank?.[languageObj?.id]}: <b>{bank?.description || ''}</b><br />
                                            {labels?.account?.[languageObj?.id]}: <b>{bankAccount?.number || ''}</b><br />
                                            {labels?.type?.[languageObj?.id]}: <b>{
                                                bankAccount.type === 'C'
                                                    ? labels?.current?.[languageObj?.id]
                                                    : labels?.savings?.[languageObj?.id]
                                            }</b><br />
                                            {labels?.coin?.[languageObj?.id]}: <b>{coin?.description || ''}</b><br />
                                            {labels?.date?.[languageObj?.id]}: <b>{
                                                dateTimeFormatGlobalSet({
                                                    date: bankAccount?.date,
                                                    type: languageObj?.format?.date?.f1,
                                                    format: 0,
                                                    addTime: false,
                                                    secondsShow: false,
                                                    languageId: languageObj?.id,
                                                    subMethod: currentMethod,
                                                })?.result
                                            }</b><br />
                                            {labels?.initialBalance?.[languageObj?.id]}: <b>{
                                                separatorsNumbersSet({
                                                    number: numberSet({
                                                        number: bankAccount?.initialBalance,
                                                        type: 'd',
                                                        languageId: languageObj?.id,
                                                        subMethod: currentMethod,
                                                    })?.result,
                                                    withDecimals: true,
                                                    consoleLogErrorShow: true,
                                                    subMethod: currentMethod,
                                                })?.result
                                            }</b><br />
                                            {labels?.currentBalance?.[languageObj?.id]}: <b>{
                                                separatorsNumbersSet({
                                                    number: numberSet({
                                                        number: bankAccount?.currentBalance,
                                                        type: 'd',
                                                        languageId: languageObj?.id,
                                                        subMethod: currentMethod,
                                                    })?.result,
                                                    withDecimals: true,
                                                    consoleLogErrorShow: true,
                                                    subMethod: currentMethod,
                                                })?.result
                                            }</b><br />
                                            {labels?.status?.[languageObj?.id]}: <b>{
                                                bankAccount.inactive
                                                    ? labels?.inactive?.[languageObj?.id]
                                                    : labels?.active?.[languageObj?.id]
                                            }</b><br />
                                        </address>

                                    </div>
                                    {/* /.col */}
                                    <div className='col-sm-4 invoice-col border-left'>
                                        {labels?.filters?.[languageObj?.id]}:<br />
                                        {labels?.from?.[languageObj?.id]}: <b>{
                                            //dateTimeFormatGlobalSet(movements?.dateFrom, languageObj?.format?.date?.f1, 0, true)?.result
                                            dateTimeFormatGlobalSet({
                                                date: reportData?.dateFrom,
                                                type: languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: true,
                                                secondsShow: false,
                                                languageId: languageObj?.id,
                                                subMethod: currentMethod,
                                            })?.result
                                        }</b><br />
                                        {labels?.to?.[languageObj?.id]}: <b>{
                                            //dateTimeFormatGlobalSet(movements?.dateTo, languageObj?.format?.date?.f1, 0, true)?.result
                                            dateTimeFormatGlobalSet({
                                                date: reportData?.dateTo,
                                                type: languageObj?.format?.date?.f1,
                                                format: 0,
                                                addTime: true,
                                                secondsShow: false,
                                                languageId: languageObj?.id,
                                                subMethod: currentMethod,
                                            })?.result
                                        }</b><br />
                                        {labels?.movements?.[languageObj?.id]}: <b>{
                                            reportData?.type === 'a'
                                                ? labels?.all?.[languageObj?.id] : (reportData?.type === 'i'
                                                    ? labels?.incomes?.[languageObj?.id] : (reportData?.type === 'e'
                                                        ? labels?.egresses?.[languageObj?.id] : ''))
                                        }</b><br />
                                    </div>
                                    {/* /.col */}
                                </div>

                                {/* /.row */}
                                {/* Table row */}
                                <div className='row'>
                                    <div className='col-12 table-responsive'>
                                        <table className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '10%' }}>{labels?.date?.[languageObj?.id]}</th>
                                                    <th style={{ width: '60%' }}>{labels?.reference?.[languageObj?.id]}</th>
                                                    <th style={{ width: '15%' }} className='text-right'>{labels?.amount?.[languageObj?.id]}</th>
                                                    <th style={{ width: '15%' }} className='text-right'>{labels?.balance?.[languageObj?.id]}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    reportData?.movements?.map((detail) => (
                                                        <tr key={dataDetailGet({ processType: 0, movement: detail, subMethod: 'tr', })?.result}>
                                                            <td>{dataDetailGet({ processType: 1, movement: detail, subMethod: 'tr - 1', })?.result}</td>
                                                            <td style={{ fontSize: '13px' }}>{dataDetailGet({ processType: 2, movement: detail, subMethod: 'tr - 2', })?.result}</td>
                                                            {/* <td className='text-right'>{dataDetailGet({ processType: 3, movement: detail, subMethod: 'tr - 3', })?.result}</td> */}
                                                            <td className={`text-right ${detail?.type === 1 ? 'text-success' : 'text-danger'}`}>{dataDetailGet({ processType: 3, movement: detail, subMethod: 'table - td - 3', })?.result}</td>
                                                            <td className='text-right'>{dataDetailGet({ processType: 4, movement: detail, subMethod: 'tr - 4', })?.result}</td>
                                                        </tr>
                                                    ))
                                                }
                                                {/* {!isUndefined(movementDetails) && movementDetails.length > 0 ?
                                                        map(movementDetails, (detail) => (
                                                            <tr key={detail.id}>
                                                                <td>{detail.date}</td>
                                                                <td>{detail.reference}</td>
                                                                <td className='text-right'>{detail.amount}</td>
                                                                <td className='text-right'>{detail.balance}</td>
                                                            </tr>
                                                        )) : null
                                                    } */}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.col */}
                                </div>

                                <hr />

                                {/* /.row */}
                                <div className='row'>
                                    {/* accepted payments column */}
                                    {/* <div className='col-6'>
                                            <p className='lead'>{labels?.paymentMethods?.[languageObj?.id]}:</p>
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.visaLogo} alt='visa' />
                                            <img className='elevation-3'src={globalSettings?.images?.masterCardLogo} alt='mastercard' />
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.americanExpressLogo} alt='americanExpress' />
                                            <img className='elevation-3'src={globalSettings?.images?.payPalLogo} alt='paypal' />
                                            <img className='mx-1 elevation-3' src={globalSettings?.images?.zelleLogo} alt='zelle' />
                                            <img className='elevation-3' src={globalSettings?.images?.bankTransferLogo} alt='bankTranfer' />
                                            <p className='text-muted well well-sm shadow-none' style={{marginTop: 10}}>
                                            </p>
                                        </div> */}
                                    {/* /.col */}
                                    {/* <div className='col-6'>
                                            <p className='lead'></p>
                                            <div className='table-responsive'>
                                                <table className='table table-sm'>
                                                    <tbody><tr>
                                                        <th style={{width: '50%'}}>{labels?.subTotal?.[languageObj?.id]}:</th>
                                                        <td className='text-right'>{separatorsNumbersSet(apartmentReceipt.total)}</td>
                                                    </tr>
                                                    <tr>
                                                        <th>{labels?.tax?.[languageObj?.id]} (neutralValue%):</th>
                                                        <td className='text-right'>neutralValue</td>
                                                    </tr>
                                                    <tr>
                                                        <th>Total:</th>
                                                        <td className='text-right'>{apartmentReceipt.total}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> */}
                                    {/* /.col */}

                                    <div className='col-sm-3 col-6'>
                                        <div className='description-block border-right'>
                                            <span className={descriptionPercentageObj?.primary}><i className={icons?.caretLeft}></i> {
                                                //separatorsNumbersSet(reportData?.previousBalance)?.result
                                                separatorsNumbersSet({
                                                    number: numberSet({
                                                        number: reportData?.previousBalance,
                                                        type: 'd',
                                                        languageId: languageObj?.id,
                                                        subMethod: 'lbl - previousBalance',
                                                    })?.result,
                                                    withDecimals: true,
                                                    consoleLogErrorShow: true,
                                                    subMethod: currentMethod,
                                                })?.result
                                            }</span>
                                            <h5 className='description-header'>---</h5>
                                            <span className='description-text'>{labels?.previousBalance?.[languageObj?.id]}</span>
                                        </div>

                                    </div>

                                    <div className='col-sm-3 col-6'>
                                        <div className='description-block border-right'>
                                            <span className={descriptionPercentageObj?.success}><i className={icons?.caretUp}></i> {
                                                //separatorsNumbersSet(reportData?.income)?.result
                                                separatorsNumbersSet({
                                                    number: numberSet({
                                                        number: reportData?.income,
                                                        type: 'd',
                                                        languageId: languageObj?.id,
                                                        subMethod: 'lbl - income',
                                                    })?.result,
                                                    withDecimals: true,
                                                    consoleLogErrorShow: true,
                                                    subMethod: currentMethod,
                                                })?.result
                                            }</span>
                                            <h5 className='description-header'>---</h5>
                                            <span className='description-text'>{labels?.incomes?.[languageObj?.id]}</span>
                                        </div>

                                    </div>

                                    <div className='col-sm-3 col-6'>
                                        <div className='description-block border-right'>
                                            <span className={descriptionPercentageObj?.danger}><i className={icons?.caretDown}></i> {
                                                //separatorsNumbersSet(reportData?.expense)?.result
                                                separatorsNumbersSet({
                                                    number: numberSet({
                                                        number: reportData?.expense,
                                                        type: 'd',
                                                        languageId: languageObj?.id,
                                                        subMethod: 'lbl - expense',
                                                    })?.result,
                                                    withDecimals: true,
                                                    consoleLogErrorShow: true,
                                                    subMethod: currentMethod,
                                                })?.result
                                            }</span>
                                            <h5 className='description-header'>---</h5>
                                            <span className='description-text'>{labels?.egresses?.[languageObj?.id]}</span>
                                        </div>

                                    </div>

                                    <div className='col-sm-3 col-6'>
                                        <div className='description-block'>
                                            <span className={reportData?.movementAmount < 0 ? descriptionPercentageObj?.danger : reportData?.movementAmount > 0 ? descriptionPercentageObj?.success : descriptionPercentageObj?.primary}>
                                                <i className={reportData?.movementAmount < 0 ? icons?.caretDown : reportData?.movementAmount > 0 ? icons?.caretUp : icons?.caretRight}></i> {
                                                    //separatorsNumbersSet(reportData?.movementAmount)?.result
                                                    separatorsNumbersSet({
                                                        number: numberSet({
                                                            number: reportData?.movementAmount,
                                                            type: 'd',
                                                            languageId: languageObj?.id,
                                                            subMethod: 'lbl - movementAmount',
                                                        })?.result,
                                                        withDecimals: true,
                                                        consoleLogErrorShow: true,
                                                        subMethod: currentMethod,
                                                    })?.result
                                                }
                                            </span>
                                            <h5 className='description-header'>---</h5>
                                            <span className='description-text'>{labels?.movements?.[languageObj?.id]}</span>
                                        </div>

                                    </div>
                                </div>
                                {/* /.row */}

                                <div className='row'>
                                    <div className='col-12'>
                                        <hr style={{ height: '0.5' }} />
                                    </div>
                                </div>

                                <div className='row text-center' style={{ fontSize: 12 }}>
                                    <div className='col-sm-3 text-muted'>
                                        {`${app?.company?.name} `}
                                    </div>
                                    <div className='col-sm-3 text-muted'>
                                        {`${app?.company?.slogan}`}
                                    </div>
                                    <div className='col-sm-3 text-muted'>
                                        {`${app?.company?.url}`}
                                    </div>
                                    <div className='col-sm-3 text-muted'>
                                        {`${app?.name} / ${app?.version} / ${app?.year}`}
                                    </div>
                                </div>

                            </section>

                        </div>
                    </div>
                </div>
                :
                <div className='text-center'
                    style={{ paddingTop: '50px', }}>
                    <LoadingSection alt='loadingSection'
                        className={globalSettings?.react?.html?.overlay?.textMued}
                        //className='overlay text-muted'
                        showText={true}
                        text={messages?.processing?.[languageObj?.id]}
                        height={25}
                        hidden={!showLoading}
                        languageId={languageObj?.id}
                        width={25}
                        subMethod={currentMethod} />
                </div>
            }

            {/* </div> */}
        </div>
    )
}